import { CalculatorContextProvider } from '../../contexts';
import { CalculatorContent } from '../CalculatorContent';
import { Catalog } from '../Catalog';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Calculator(_ref) {
  var config = _ref.config,
    layoutType = _ref.layoutType,
    calculatorType = _ref.calculatorType,
    fetcherFn = _ref.fetcherFn,
    initialActiveProduct = _ref.initialActiveProduct,
    iniState = _ref.iniState,
    bgImage = _ref.bgImage,
    actions = _ref.actions;
  return /*#__PURE__*/_jsxs(CalculatorContextProvider, {
    config: config,
    fetcherFn: fetcherFn,
    calculatorType: calculatorType,
    layoutType: layoutType,
    iniState: iniState,
    initialActiveProduct: initialActiveProduct,
    actions: actions,
    children: [/*#__PURE__*/_jsx(CalculatorContent, {
      bgImage: bgImage
    }), /*#__PURE__*/_jsx(Catalog, {})]
  });
}